import { createStore } from '@stencil/store';

export type NylasTheme = Partial<{
  '--nylas-color-primary-50': string;
  '--nylas-color-primary-100': string;
  '--nylas-color-primary-200': string;
  '--nylas-color-primary-300': string;
  '--nylas-color-primary-400': string;
  '--nylas-color-primary-500': string;
  '--nylas-color-primary-600': string;
  '--nylas-color-primary-700': string;
  '--nylas-color-primary-800': string;
  '--nylas-color-primary-900': string;
  '--nylas-color-primary-950': string;
}>;

const store = createStore<NylasTheme>({});

export default store;
